import React from 'react'
import CurrencyMGA from './CurrencyMGA'

// CardCurrencySpecialCurrencies returns an introduction and any content related to special currencies.
// Import any .tsx objects that contain special currency details, and declare them after the paragraph introduction.
// Note: CardCurrencySpecialCurrencies doesn't check whether there are any special currencies.
// Declare all special currencies defined in the folder for CardCurrencySpecialCurrencies.
// Add these declarations in alphabetical order by the name of the currency, starting at line 19.
// If there are no special currencies declared, don't call this object.

const CardCurrencySpecialCurrencies = () => {
  return (
    <>
      <h2>Special currencies</h2>
      <p>
        The following section provides details about the currencies that require
        special integration:
      </p>
      <CurrencyMGA />
    </>
  )
}

export default CardCurrencySpecialCurrencies
